export class ChatUserSelectionEdit
{
    public chatId = null;
    public spaceId = null;
    public spaceName = null;
    public spaceDescription = null;
    public users = [];
}
